import { readJson } from "#app/utils/json";
/**
 * Client-side token stats utilities
 *
 * Functions to fetch and manage user token statistics
 */

interface UserTokenStats {
  userId: string;
  monthlyTokens: number;
  totalTokens: number;
  messageCount: number;
  firstMessageAt: string | null;
  lastMessageAt: string | null;
}

/**
 * Fetch user token statistics from the API
 */
async function fetchUserTokenStats(): Promise<UserTokenStats | null> {
  try {
    const response = await fetch("/api/v1/user/token-stats", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      if (response.status === 401) {
        console.warn("User not authenticated for token stats");
        return null;
      }
      throw new Error(`Failed to fetch token stats: ${response.status}`);
    }

    return await readJson<UserTokenStats>(response);
  } catch (error) {
    console.error("Error fetching user token stats:", error);
    return null;
  }
}

/**
 * Load user token stats and update the chat store
 */
export async function loadUserTokenStats(
  setMonthlyTokenCount: (count: number) => void,
): Promise<void> {
  try {
    const stats = await fetchUserTokenStats();
    if (stats) {
      setMonthlyTokenCount(stats.monthlyTokens);
      console.log(`Loaded monthly token count: ${stats.monthlyTokens}`);
    }
  } catch (error) {
    console.error("Error loading user token stats:", error);
  }
}
